<template>
  <div>
    <page-header
      title="Messaging"
      breadcrumb="Dashboard > Settings > Messaging"
    />
    <div class="bg-white p-3">
      <div class="flex justify-between mt-2 mb-0">
        <div class="flex">
          <div
            v-for="topTab in topTabs"
            :key="topTab"
            class="tab-item"
            :class="{ active: currentTab == topTab }"
            @click="currentTab = topTab"
          >
            <p>{{ topTab }}</p>
          </div>
        </div>
      </div>
      <hr class="below_line"/>
    </div>
 
    <div class="bg-white p-3">
      <component :is="currenTab"></component>
    </div>


  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import MessageIndex from "@/components/3pl/Settings/Messaging/index"

export default {
  components: { PageHeader, MessageIndex },
  data() {
    return {
      currentTab: 'Customer Satisfaction',
      topTabs: [
        'Account Settings', 'Categories & SLA', 'Channels', 'Ticket Fields', 'Customer Satisfaction'
      ]
    }
  },
  computed: {
    currenTab(){
      return "MessageIndex"
    }
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
    cursor: pointer;
    // margin-right: 1rem;
    color: #5e646d;
    padding: 0.5rem 1.5rem;
    font-size: 0.9rem;
    @apply bg-gray-200;
    &.active {
      background: #ffffff;
      box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
      border-radius: 5px;
      color: #fcc210;
      font-weight: bold;
    }
  }
  .below_line{
    all: onset;
    border-bottom: 1px solid rgb(188, 183, 183);
  }
</style>
